import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPrimeTwitter = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_21718_3336)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_21718_3336",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 14,
			height: 14,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M0 0H14V14H0V0Z",
				fill: "white"
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_21718_3336)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M11.025 0.656006H13.172L8.482 6.03001L14 13.344H9.68L6.294 8.90901L2.424 13.344H0.275L5.291 7.59401L0 0.657006H4.43L7.486 4.71001L11.025 0.656006ZM10.27 12.056H11.46L3.78 1.87701H2.504L10.27 12.056Z",
				fill: "#A3A3A3"
			})
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_21718_3336",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 14,
			height: 14,
			fill: "white"
		})
	}) })]
});
export default SvgPrimeTwitter;
